





import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class HomePage extends Vue {
  public get homePageComponent() {
    return () => import(`@/components/homePage/HomePage.${this.$i18n.locale}`);
  }
}
